import { n as o } from "./property-9daa16cd.mjs";
import { r as g } from "./state-7560d4dc.mjs";
import { e as v } from "./query-d94c86d2.mjs";
import { i as m, E as f, x as s, a as d, r as b } from "./createReactComponent-58f9bea8.mjs";
import { e as p } from "./class-map-2994e95e.mjs";
import { o as h } from "./if-defined-47693dfa.mjs";
import { l as y } from "./live-6c85dd15.mjs";
import { p as u } from "./purify.es-39f8036b.mjs";
import { S as _ } from "./slot-controller-fa97ce97.mjs";
import { r as $ } from "./icon-button-a9d2a2d1.mjs";
import { r as w } from "./icon-c572aa57.mjs";
import { r as I } from "./tooltip-cb602d1f.mjs";
const z = m`
  :host {
    display: block;
    box-sizing: border-box;
    --exo-component-textarea-margin-bottom: var(--exo-spacing-medium);
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host .form-control {
    position: relative;
    margin-bottom: var(--exo-component-textarea-margin-bottom);
  }

  :host .form-control .form-control__label {
    display: none;
  }

  /* Form Control Label */
  :host .form-control--has-label .form-control__label {
    display: inline-flex;
    align-items: center;
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font);
    margin-bottom: var(--exo-spacing-2x-small);
  }

  /* Form Control Label Info Icon */
  :host .form-control--has-label .form-control__label-info-icon {
    margin-left: var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-medium);
    display: block;
  }

  :host
    .form-control--has-label
    .form-control__label
    > .form-control__additional-text {
    color: var(--exo-color-font-secondary);
    margin-left: var(--exo-spacing-2x-small);
  }

  /* Form Control Help Text */
  :host .form-control__info-error-texts,
  :host .form-control__invalid-text {
    display: flex;
    align-items: flex-start;
    gap: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-secondary);
  }

  :host .form-control__info-error-texts {
    margin-top: var(--exo-spacing-2x-small);
    justify-content: space-between;
  }

  :host .form-control__help-text {
    display: flex;
    margin-bottom: var(--exo-spacing-2x-small);
    gap: var(--exo-spacing-2x-small);
  }

  :host .form-control__invalid-text {
    color: var(--exo-color-font-danger);
  }

  :host .form-control__invalid-text .error-icon {
    margin-top: var(--exo-spacing-4x-small);
  }

  /* Textarea */
  :host .textarea {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    background-color: var(--exo-color-page);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    border-radius: var(--exo-radius-standard);
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-none)
      var(--exo-spacing-2x-small) var(--exo-spacing-x-small);
    gap: var(--exo-spacing-x-small);
    font: var(--exo-text-label-standard);
  }

  ::-webkit-resizer {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg height='18' viewBox='0 0 18 18' width='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m14.228 16.227a1 1 0 0 1 -.707-1.707l1-1a1 1 0 0 1 1.416 1.414l-1 1a1 1 0 0 1 -.707.293zm-5.638 0a1 1 0 0 1 -.707-1.707l6.638-6.638a1 1 0 0 1 1.416 1.414l-6.638 6.638a1 1 0 0 1 -.707.293zm-5.84 0a1 1 0 0 1 -.707-1.707l12.477-12.477a1 1 0 1 1 1.415 1.414l-12.478 12.477a1 1 0 0 1 -.707.293z' fill='%238c8c8c'/%3E%3C/svg%3E");
  }

  :host
    .textarea:hover:not(.textarea--disabled):not(.textarea--invalid):not(
      .textarea--focused
    ) {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .textarea.textarea--focused:not(.textarea--disabled) {
    border-color: var(--exo-color-border-tertiary);
    outline: var(--exo-spacing-4x-small) solid var(--exo-color-border-tertiary);
  }

  :host .textarea.textarea--disabled {
    border-color: var(--exo-color-border-secondary);
    opacity: var(--exo-opacity-4);
    cursor: not-allowed;
  }

  :host .textarea.textarea--disabled .textarea__control {
    color: var(--exo-color-font-disabled);
  }

  :host .textarea.textarea--invalid {
    border-color: var(--exo-color-border-danger-strong);
    background: var(--exo-color-background-danger-weak);
  }

  :host .textarea--invalid ::selection {
    background: var(--exo-color-background-danger-weak);
  }

  :host .textarea.textarea--focused.textarea--invalid {
    border-color: var(--exo-color-border-danger-strong);
    outline: var(--exo-spacing-4x-small) solid
      var(--exo-color-border-danger-strong);
    background: var(--exo-color-background);
  }

  /* Textarea Control */
  :host .textarea__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: var(--exo-spacing-none);
    line-height: var(--exo-line-height-denser);
    color: var(--exo-color-font);
    border: none;
    background: none;
    box-shadow: none;
    padding-right: var(--exo-spacing-x-small);
    margin: var(--exo-spacing-none);
    cursor: inherit;
    -webkit-appearance: none;
    min-height: var(--exo-spacing-x-large);
  }

  :host .textarea__control:focus {
    outline: none;
  }

  :host .textarea__control::placeholder {
    color: var(--exo-color-font-secondary);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /*
  * Resize types
  */

  .textarea--resize-none .textarea__control {
    resize: none;
  }

  .textarea--resize-vertical .textarea__control {
    resize: vertical;
  }

  #char-count {
    white-space: nowrap;
    margin-left: var(--exo-spacing-standard);
  }

  :host ex-tooltip {
    z-index: 1;
  }

  /* textarea leading icon */

  :host .textarea__leading-icon {
    cursor: auto;
    color: var(--exo-color-border);
  }

  :host .textarea:hover .textarea__leading-icon,
  :host .textarea.textarea--focused .textarea__leading-icon,
  :host .textarea.textarea--invalid .textarea__leading-icon {
    color: var(--exo-color-background-info-strong);
  }

  :host .textarea.textarea--disabled .textarea__leading-icon {
    color: var(--exo-color-background-disabled);
  }

  /* textarea Footer Type */

  :host .textarea__footer-info {
    color: var(--exo-color-background-info-strong);
  }

  :host .textarea__footer-success {
    color: var(--exo-color-background-success-strong);
  }

  :host .textarea__footer-error {
    color: var(--exo-color-background-danger-strong);
  }

  :host .textarea__footer-warning {
    color: var(--exo-color-background-warning-strong);
  }
`;
var k = Object.defineProperty, T = Object.getOwnPropertyDescriptor, t = (i, a, r, l) => {
  for (var c, n = l > 1 ? void 0 : l ? T(a, r) : a, x = i.length - 1; x >= 0; x--)
    (c = i[x]) && (n = (l ? c(a, r, n) : c(n)) || n);
  return l && n && k(a, r, n), n;
}, C = ((i) => (i.INFO = "info", i.SUCCESS = "success", i.ERROR = "error", i.WARNING = "warning", i))(C || {});
class e extends f {
  constructor() {
    super(...arguments), this.hasFocus = !1, this.slotController = new _(this, "label", "help-text"), this.value = "", this.label = "", this.leadingIcon = "", this.showLeadingIcon = !1, this.helpText = "", this.showStatusIcon = !1, this.footerType = "info", this.infoText = "", this.errorMsg = "", this.rows = 8, this.resize = "vertical", this.disabled = !1, this.readonly = !1, this.required = !1, this.optional = !1, this.invalid = !1, this.dangerouslyUseHTML = !1, this.statusIconlabel = "", this.leadingIconlabel = "";
  }
  dispatchCustomEvent(a) {
    const r = new CustomEvent(a, { bubbles: !0, cancelable: !1, composed: !0, detail: {} });
    this.dispatchEvent(r);
  }
  blur() {
    this.input.blur();
  }
  handleBlur() {
    this.hasFocus = !1, this.dispatchCustomEvent("onBlur");
  }
  handleFocus() {
    this.hasFocus = !0, this.dispatchCustomEvent("onFocus");
  }
  avoidSanitization() {
    return this.dangerouslyUseHTML;
  }
  handleChange() {
    if (this.avoidSanitization())
      this.value = this.input.value;
    else {
      const a = this.input.value, r = u.sanitize(a);
      this.value = r;
    }
    this.dispatchCustomEvent("onChange");
  }
  handleInput() {
    if (this.avoidSanitization())
      this.value = this.input.value;
    else {
      const a = this.input.value, r = u.sanitize(a);
      this.value = r;
    }
    this.dispatchCustomEvent("onInput");
  }
  handleInvalid() {
    this.invalid = !0;
  }
  update(a) {
    super.update(a), a.has("disabled") && a.get("disabled") !== this.disabled && this.hasUpdated && (this.input.disabled = this.disabled, this.invalid = !this.input.checkValidity()), a.has("value") && a.get("value") !== this.value && this.hasUpdated && (this.invalid = !this.input.checkValidity());
  }
  getValidationErrorMsg() {
    var a, r, l, c, n;
    return (a = this.errorMsg) != null && a.length && ((l = (r = this.input) == null ? void 0 : r.validationMessage) != null && l.length || this.invalid) ? this.errorMsg : (n = (c = this.input) == null ? void 0 : c.validationMessage) != null && n.length ? this.input.validationMessage : "Invalid input";
  }
  renderAdditionalLabelText() {
    return this.required ? s`<span class="form-control__additional-text">
        (required)
      </span>` : this.optional ? s`<span class="form-control__additional-text">
        (optional)
      </span>` : "";
  }
  renderInfoText() {
    return this.infoText ? s`<ex-tooltip
        position="top"
        alignment="start"
        class="form-control__label-info-icon"
      >
        <div>${this.infoText}</div>
        <span slot="anchor">
          <ex-icon-button
            icon="information"
            flavor="branded"
            type="tertiary"
            size="x-small"
            circular="true"
          ></ex-icon-button>
        </span>
      </ex-tooltip> ` : d;
  }
  getFooterType() {
    return this.helpText ? s`<div class="form-control__help-text">
        <slot name="help-text">${this.setStatusIcon()}${this.helpText}</slot>
      </div>` : d;
  }
  renderErrorMessage(a) {
    return this.invalid && a ? s`<div
        part="form-control-invalid-text"
        id="invalid-text"
        class="form-control__invalid-text"
        aria-invalid=${this.invalid ? "false" : "true"}
        aria-live="polite"
      >
        <ex-icon
          class="error-icon"
          size="XS"
          icon="Error"
          variant="danger"
        ></ex-icon>
        <slot name="error-text">${a}</slot>
      </div>` : d;
  }
  renderMaxLengthText() {
    return this.maxlength && this.maxlength > 0 ? s`<div id="char-count" aria-live="polite">
        ${this.value.length} / ${this.maxlength}
      </div>` : d;
  }
  setStatusIcon() {
    if (this.showStatusIcon)
      switch (this.footerType) {
        case "success":
          return s`<ex-icon
            size="XS"
            icon="Success"
            label=${this.statusIconlabel}
          ></ex-icon>`;
        case "error":
          return s`<ex-icon
            size="XS"
            icon="Error"
            label=${this.statusIconlabel}
          ></ex-icon>`;
        case "warning":
          return s`<ex-icon
            size="XS"
            icon="Warning"
            label=${this.statusIconlabel}
          ></ex-icon>`;
        default:
          return s`<ex-icon
            size="XS"
            icon="Information"
            label=${this.statusIconlabel}
          ></ex-icon>`;
      }
    return d;
  }
  setLeadingIcon() {
    return this.showLeadingIcon ? s` <ex-icon
        class="textarea__leading-icon"
        icon=${this.leadingIcon}
        size="S"
        label=${this.leadingIconlabel}
      ></ex-icon>` : d;
  }
  render() {
    const a = this.slotController.test("label"), r = !!this.label || !!a, l = this.slotController.test("help-text"), c = !!this.helpText || !!l, n = this.getValidationErrorMsg(), x = this.invalid && n ? this.renderErrorMessage(n) : s`<span class="textarea__footer-${this.footerType}"
            >${this.getFooterType()}</span
          >`;
    return s`
      <div
        class=${p({ "form-control": !0, "form-control--has-label": r, "form-control--has-help-text": c, "form-control--has-error-text": this.invalid && n })}
      >
        <label
          class="form-control__label"
          for="textarea"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label"> ${this.label} </slot>
          ${this.renderInfoText()} ${this.renderAdditionalLabelText()}
        </label>
        <div class="form-control__textarea">
          <div
            part="textarea"
            class=${p({ textarea: !0, "textarea--disabled": this.disabled, "textarea--focused": this.hasFocus, "textarea--empty": !this.value, "textarea--invalid": this.invalid, "textarea--resize-none": this.resize === "none", "textarea--resize-vertical": this.resize === "vertical" })}
          >
            ${this.setLeadingIcon()}
            <textarea
              id="textarea"
              class="textarea__control"
              name=${h(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${h(this.placeholder)}
              minlength=${h(this.minlength)}
              maxlength=${h(this.maxlength)}
              .value=${y(this.value)}
              ?autofocus=${this.autofocus}
              spellcheck=${h(this.spellcheck)}
              aria-describedby="char-count"
              aria-invalid=${this.invalid ? "true" : "false"}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              rows=${h(this.rows)}
            ></textarea>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__info-error-texts"
          aria-hidden=${c ? "false" : "true"}
        >
          <div>${x}</div>
          <div>${this.renderMaxLengthText()}</div>
        </div>
      </div>
    `;
  }
}
e.styles = z, t([v(".textarea__control")], e.prototype, "input", 2), t([g()], e.prototype, "hasFocus", 2), t([o()], e.prototype, "name", 2), t([o()], e.prototype, "value", 2), t([o()], e.prototype, "label", 2), t([o()], e.prototype, "leadingIcon", 2), t([o({ type: Boolean })], e.prototype, "showLeadingIcon", 2), t([o({ attribute: "help-text" })], e.prototype, "helpText", 2), t([o({ type: Boolean, reflect: !0 })], e.prototype, "showStatusIcon", 2), t([o()], e.prototype, "footerType", 2), t([o({ attribute: "info-text" })], e.prototype, "infoText", 2), t([o({ attribute: "error-msg" })], e.prototype, "errorMsg", 2), t([o()], e.prototype, "placeholder", 2), t([o({ type: Number })], e.prototype, "rows", 2), t([o()], e.prototype, "resize", 2), t([o({ type: Boolean, reflect: !0 })], e.prototype, "disabled", 2), t([o({ type: Boolean, reflect: !0 })], e.prototype, "readonly", 2), t([o({ type: Number })], e.prototype, "minlength", 2), t([o({ type: Number })], e.prototype, "maxlength", 2), t([o({ type: Boolean, reflect: !0 })], e.prototype, "required", 2), t([o({ type: Boolean })], e.prototype, "optional", 2), t([o({ type: Boolean, reflect: !0 })], e.prototype, "invalid", 2), t([o({ type: Boolean })], e.prototype, "autofocus", 2), t([o({ type: Boolean })], e.prototype, "spellcheck", 2), t([o({ type: Boolean })], e.prototype, "dangerouslyUseHTML", 2), t([o({ type: String })], e.prototype, "statusIconlabel", 2), t([o({ type: String })], e.prototype, "leadingIconlabel", 2);
const j = (i = "") => {
  b("ex-textarea", e, i), $(i), w(i), I(i);
};
export {
  C as T,
  e as a,
  j as r
};
